<template>
  <div class="pb-12 poppins" v-if="serverData">
    <div class="px-4" style="display: flex; justify-content: end">
      <v-icon size="36" color="pink" @click="toggleModal"
        >mdi-fullscreen</v-icon
      >
    </div>

    <DashboardAsnFloorGroup
      :counters="counters"
      :items="items"
      :headers="headers"
    />

    <v-dialog v-model="dialog" fullscreen>
      <div
        style="
          background-color: #ebedf3;
          min-height: fit-content;
          height: 100vh;
          width: 100%;
          position: relative;
          overflow-y: hidden !important;
        "
        class="pt-16 pt-md-0"
      >
        <div class="h-100 zindex-5 scroll-y">
          <div
            class="px-4 pt-2 pb-0 position-absolute"
            style="
              display: flex;
              justify-content: end;
              bottom: -250px;
              right: 0;
            "
          >
            <v-icon x-large color="pink" @click="toggleModal"
              >mdi-fullscreen-exit</v-icon
            >
          </div>
          <DashboardAsnFloorGroup
            :counters="counters"
            :items="items"
            :headers="headers"
          />
        </div>
      </div>
    </v-dialog>
  </div>
</template>

<script>
import ApiService from "@/core/services/api.service";
import { SET_PAGE_LOADING } from "@/core/services/store/config.module";
import DashboardAsnFloorGroup from "@/own/components/dashboard/DashboardAsnFloorGroup.vue";
export default {
  components: { DashboardAsnFloorGroup },
  name: "DashboardAsnFloor",
  data: () => ({
    dialog: false,
    headers: [],
    items: [],
    counters: [],
    serverData: null,
    refreshDataIntervalId: null,
    groupIntervalId: null,
    itemIndex: -1,
  }),
  beforeMount() {
    this.$store.commit(SET_PAGE_LOADING, true);
    this.loadInitialDataFromServer();
    this.startAutoRefresh();
    setTimeout(() => {
      this.dialog = true;
    }, 1000);
  },
  beforeDestroy() {
    this.stopIntervals();
  },
  methods: {
    startAutoRefresh() {
      this.refreshDataIntervalId = setInterval(() => {
        this.loadInitialDataFromServer();
      }, 300000);
    },
    stopIntervals() {
      clearInterval(this.refreshDataIntervalId);
    },
    toggleModal() {
      this.dialog = !this.dialog;
    },
    loadInitialDataFromServer() {
      let filterData = {
        date_range_type: "custom",
        date_range: ["2021-01-15", "2021-02-14"],
      };
      ApiService.post("/dashboards/dashboardAsnFloor", filterData)
        .then((response) => {
          this.serverData = response.data;
          this.counters = response.data.counters;
          this.headers = response.data.datatable.header;
          this.items = response.data.datatable.body;
          this.$store.commit(SET_PAGE_LOADING, false);
        })
        .catch((error) => {})
        .finally(() => {
          this.$store.commit(SET_PAGE_LOADING, false);
        });
    },
  },
};
</script>
